import { gql, useQuery } from "@apollo/client";

const GetTeacherCreatedAtQuery = gql`
  query getTeacherCreatedAt($id: String!) {
    getFranchiseeById(id: $id) {
      id
      createdAt
    }
  }
`;

type GetTeacherCreatedAtQueryResult = {
  getFranchiseeById?: { id: string; createdAt?: string | null } | null;
};

export function useTeacherCreatedAt(teacherId: string) {
  const { data } = useQuery<GetTeacherCreatedAtQueryResult>(
    GetTeacherCreatedAtQuery,
    { variables: { id: teacherId } },
  );
  return data?.getFranchiseeById?.createdAt ?? null;
}
